import React, { useState } from 'react';
import '../Default.css';
import './SignIn.css';
import TermsOfUse from '../terms_of_use/TermsOfUse';
import PrivacyPolicy from '../privacy_policy/PrivacyPolicy';

type ErrorMsg = {
    tokenError: string;
    consentError: string;
}

function SignIn() {

    const [inputToken, setInputToken] = useState("" as string);
    const [isConsent, setIsConsent] = useState(false as boolean);
    const [errorMsg, setErrorMsg] = useState({ tokenError: "", consentError: "" } as ErrorMsg);

    const [showTermsOfUse, setShowTermsOfUse] = useState(false as boolean);
    const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false as boolean);

    const signIn = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        setErrorMsg({ tokenError: "", consentError: "" } as ErrorMsg);

        if (inputToken === "") {
            setErrorMsg({ tokenError: "Pole token nie może być puste!", consentError: "" });
            return;
        }

        if (isConsent !== true) {
            setErrorMsg({ tokenError: "", consentError: "Zaakceptowanie polityki prywatności jest wymagane!" });
            return;
        }

        const token = inputToken;

        document.cookie = `token=${token}; SameSite=Strict;`
        fetch("/api/user/id") // auto verify
        .then(r => {
          if(r.status === 200){
            r.json().then(({id, admin}: {id: string, admin: boolean}) => {
                window.location.href = `/?token=${token}&id=${id}&admin=${admin}`
                console.log(`got userID ${id}`);
            })
          }
          else{
            window.location.href = "/?token=&id=&login=fail"

          }
        }
        )
    }


    if (showTermsOfUse)
    {
        return (
            <>
                <TermsOfUse />
                <div className='sign-in-back-from'>
                    <img onClick={() => setShowTermsOfUse(false)} src="/icons/angle-left-solid.svg" alt="undo" className='img'></img>
                </div>
            </>
        )
    }

    if (showPrivacyPolicy)
    {
        return (
            <>
                <PrivacyPolicy />
                <div className='sign-in-back-from'>
                    <img onClick={() => setShowPrivacyPolicy(false)} src="/icons/angle-left-solid.svg" alt="undo" className='img'></img>
                </div>
            </>
        )
    }


    return (
        <>
            <div className="page-title">Logowanie</div>
            <form className='form sign-in'
                onSubmit={(e: React.FormEvent<HTMLFormElement>) => signIn(e)}
            >   
                <div>
                    <p className='error-msg'>{errorMsg.tokenError}</p>
                </div>                
                <div>
                    <label htmlFor="token">Token:</label>
                    <input
                        type="text"
                        id="token"
                        name="token"
                        autoComplete="off"
                        value={inputToken}
                        onChange={e => setInputToken(e.target.value)}
                        required
                    />
                </div>

                <div>
                    <p className='error-msg'>{errorMsg.consentError}</p>
                </div>
                <div className='row-justify-content'>
                    <input 
                        type="checkbox" 
                        name="consent"
                        id="consent"
                        checked={isConsent}
                        onChange={e => setIsConsent(e.target.checked)} 
                    />
                    <label htmlFor="consent">
                        <div>Akceptuję</div>
                        <b onClick={() => setShowPrivacyPolicy(true)}> Politykę prywatności </b>
                    </label>
                </div>

                <div>
                    <button>Zaloguj</button>
                </div>
            </form>       
        </>
    )
}

export default SignIn;